import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import SeminarMode from './routes/SeminarMode'
import Recordings from './routes/SeminarMode/Recordings'
import PrepareMobile from './routes/PrepareSession/mobile'
import { checkJapanese, checkMobile, flattenMessages, getUrlParams } from './lib/lib'
import { addLocaleData, IntlProvider } from 'react-intl'
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import config from './config/config'
import messages from './messages'
import ReactGA from 'react-ga'

addLocaleData([...en, ...ja])
const Routes = (api) => {
  let roomPath = '/webinar/'

  if (window.location.pathname === '/test') { // for debug
    if (config.API_HOST === 'workshop.tokyo') {
      window.location.href = '/webinar/?token=' + config.WEBINAR_PROD_TEST2_DEBUG_TOKEN
    } else {
      window.location.href = '/webinar/?token=' + config.WEBINAR_DEV_TEST2_DEBUG_TOKEN
    }
    return
  }

  if (window.location.hostname !== 'localhost') {
    if (window.location.host === 'dd-talk.net' || window.location.host === 'video-dev.dd-talk.net') {
      ReactGA.initialize('UA-132878730-1')
      ReactGA.pageview(window.location.host + window.location.pathname + window.location.search)
    }
    if (window.location.host === 'video.workshop-live.com' || window.location.host === 'video-dev.workshop-live.com') {
      ReactGA.initialize('UA-132878730-3')
      ReactGA.pageview(window.location.host + window.location.pathname + window.location.search)
    }

    var full = window.location.host
    var parts = full.split('.')
    var sub = parts[1]

    if (sub === 'lfv') {
      ReactGA.initialize('UA-132878730-4')
      ReactGA.pageview(window.location.host + window.location.pathname + window.location.search)
    }
  }

  return (
    <Router>
      <Switch>
        {/* Routes and the layouts for a logged out user */}
        <Route exact path='/' component={PrepareMobile}/>
        <Route path="/recordings" component={Recordings}/>
        <Route exact path={roomPath} render={(api) => {
          let hashes = getUrlParams(api.location.search)
          if (!hashes.mobile && checkMobile()) {
            return (<PrepareMobile api={api}/>)
          }
          return (
            <IntlProvider
              locale={checkJapanese() ? 'ja' : 'en'}
              messages={flattenMessages(
                messages[checkJapanese() ? 'ja' : 'en'])}>
              <SeminarMode location='/webinar/' api={api}/>
            </IntlProvider>
          )
        }}/>
        <Route component={NoMatch}/>
      </Switch>
    </Router>)
}

const NoMatch = ({location}) => {
  window.setTimeout('window.location=(\'https://admin.workshop-live.com/\');', 3000)

  return (
    <section className='flex items-center flex-column justify-center h-100 bg-washed-blue'>
      <header class='tc ph5 lh-copy'>
        <h1 className='f1 f-headline-l w-100 tc code mb3 fw9 dib tracked-tight light-purple'>404</h1>
        <h2 className='tc f1-l fw1'>指定されたページはみつかりません。3秒後にトップへ戻ります。 <code>{location.pathname}</code></h2>
      </header>
    </section>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.js